import { render, staticRenderFns } from "./LeaderboardCompanyCompetition.vue?vue&type=template&id=6fbc8d72"
import script from "./LeaderboardCompanyCompetition.vue?vue&type=script&lang=js"
export * from "./LeaderboardCompanyCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports